<template>
    <card :title="materialTitle" class="mtop-10" :body-class="{'hidden': selectionConfirmed}" :loader="loadingPrice">
      <template slot="buttons">
        <button v-if="selectionConfirmed" type="button" class="btn btn-primary" v-on:click="revertSelection"><i class="fa fa-repeat"></i> {{ $t('Action.changeSelection') }}</button>
        <button v-else :disabled="!productSelected" type="button" class="btn btn-success" v-on:click="confirmSelection"><i class="fa fa-edit"></i> {{ $t('Action.confirmSelection') }}</button>
      </template>
      <finder
        :tree="productTree"
        :selection="selection"
        frame-classes="col-md-4 col-sd-4 col-xs-4"
        v-on:clickchild="selectProductLocal"
      />
  </card>
</template>

<script>
import FormsMixin from '../Mixins/Forms.js';
import ProductPickerMixin from '../Mixins/ProductPicker.js';
import Finder from '../Elements/Finder.vue';
import Card from '../Elements/Card.vue'


var view = require('../view.js'),
  viewData = {
    images: [],
    frames: [],
    selection: [],
    selectionConfirmed: false,
    productSelected: false,
    isSameMaterial: null,
    isSameMaterialValue: true, // Checkbox value (unconfirmed)
    requireAttachments: [],
    itemnums: [],
    properties: [],
    formValues: {},
    maxunits: 0,
    loadingPrice: '',
    allowMultiple: true,
    cart: {}
  },
  resetData = Object.assign({}, viewData);

export default view(viewData, {
  name: 'InlineFinder',
  mixins: [ ProductPickerMixin, FormsMixin ],
  components: {
    Finder,
    Card
  },
  props: {
    id: {},
    productTree: {},
    value: {}
  },
  mounted() {
    console.log('mounted.InlineFinder', this.value);
    const value = this.value && this.value.selection ? this.value.selection : (this.value || []); 
    this.updateSelection(value || []);

    const lastSelection = (this.selection || []).slice().pop();
    const lastObject = this.collectProperties(this.selection, 'children').pop();

    this.productSelected = lastObject[lastSelection].children == null;

    setTimeout(() => {
      this.$emit('valid', this.productSelected);
      this.$emit('input', {
        selection: this.selection,
      }, this.id)
    }, 100);

    if (this.productFilter.length == 0) {
      return;
    }
    this.getFilteredTree(this.productTree, this.productFilter);
  },
  computed: {
    materialTitle() {
      var title = this.$t('ProjectDetails.materialSelection');

      if (this.selectionConfirmed) {
        return title + ': ' + this.getMaterialSelection();
      }

      return title;
    },
    formConverted() {
      const f = this.form;
      return Object.keys(f).map(id => Object.assign({}, f[id], {
        id,
      }))
    }
  },
  methods: {
    getBranch() {
      return this.productTree;
    },
    async confirmSelection() {
      this.selectionConfirmed = true;
      this.formValues = {};

      let selectedProduct = this.productTree;
      if (selectedProduct.children && this.selection.length) {
        for (let selectionItem of this.selection) {
          selectedProduct = selectedProduct.children[selectionItem];
        }
      }
      this.productTree.children

      this.$emit('valid', true);
      this.$emit('input', {
        selection: this.selection,
        selectedProduct,
      }, {id: this.id, name: this.id, productTree: this.productTree});
      this.$forceUpdate();
    },

    getMaterialSelection(selection) {
      if (typeof selection == 'undefined') {
        selection = this.selection;
      }
      var labels = this.collectProperties(selection, 'label');
      labels.shift();

      let localizedLabels = [];
      labels.forEach((l) => {
        localizedLabels.push(this.$root.getLabelText(l));
      });

      return localizedLabels.join(' › ');
    },

    selectProductLocal(...args) {
      this.selectProduct(...args);
      console.log('selectProductLocal.selection', this.selection);
      this.$emit('valid', this.productSelected);
      // this.$emit('input', this.selection, this.id)
      this.$forceUpdate();
    }
  }
})
</script>
